import React from 'react'
import { useIsMobile } from 'spa/member/hooks/v2/useIsMobile'
import { BlockContainer } from 'spa/member/components/Top/BlockContainer'
import { ServiceFeatureJobOffers } from './ServiceFeatureJobOffers'
import { ServiceFeatureDetails } from './ServiceFeatureDetails'
import styles from './ServiceFeatures.module.scss'

export const StyledServiceFeatures: React.FC = () => {
  const isMobile = useIsMobile()
  const sectionDescription = () => {
    return isMobile
      ? ['クラウドワークス テックはフリーランスが', 'もっと柔軟に働ける社会を目指す、', 'エージェントマッチングサービスです。']
      : ['クラウドワークス テックはフリーランスがもっと柔軟に働ける社会を目指す、', 'エージェントマッチングサービスです。']
  }

  return (
    <BlockContainer title='サービスの特徴' text={sectionDescription()} className={styles.container}>
      <ServiceFeatureJobOffers />
      <ServiceFeatureDetails />
    </BlockContainer>
  )
}
